import React from 'react';
import { RouterProvider } from 'react-router-dom';

// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Notistack from 'ui-component/third-party/Notistack';

import ThemeCustomization from 'themes';
import { ToastContainer, toast } from 'react-toastify';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { getGeoData } from 'api/UserApi';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const pageBlockByIP = async () => {
            try {
                setLoading(true);
                const geoData = await getGeoData();

                const geoModelTmp = geoData?.data ?? null;

                if (!geoModelTmp || !geoModelTmp.allowed) {
                    // debugger;
                    if (!window.location.pathname.includes('accessdenied') && !window.location.pathname.includes('maintenance')) {
                        window.location.replace('/accessdenied');
                        return;
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                }

                // setGeoModel(geoModelTmp);
            } catch (error) {
                console.error('Error fetching geo data:', error);
                setLoading(false);
            }
        };
        pageBlockByIP();
    }, []);

    console.log('geo loading ', loading);

    return (
        <ThemeCustomization>
            {/* <RTLLayout> */}
            <Locales>
                <ToastContainer />
                <NavigationScroll>
                    <AuthProvider>
                        <>
                            <Notistack>
                                <RouterProvider router={router} />
                                <Snackbar />
                            </Notistack>
                        </>
                    </AuthProvider>
                </NavigationScroll>
            </Locales>
            {/* </RTLLayout> */}
        </ThemeCustomization>
    );
};

export default App;
